"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressHorizontal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const typography_1 = require("../../shared/typography");
const utils_1 = require("./utils");
const ProgressHorizontal = ({ percent, status, left, right }) => {
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { percent: percent, color: (0, utils_1.resolveColor)(status), children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(typography_1.H4, { "data-testid": "progress-horizontal-left", children: left }, void 0), (0, jsx_runtime_1.jsx)(typography_1.H4, { "data-testid": "progress-horizontal-right", children: right }, void 0)] }, void 0), (0, jsx_runtime_1.jsx)("div", {}, void 0)] }, void 0));
};
exports.ProgressHorizontal = ProgressHorizontal;
const Wrapper = styled_components_1.default.div `
  div:first-of-type {
    display: flex;
    justify-content: space-between;
  }

  h4 {
    color: ${({ theme }) => theme.colors.greyBase};
    display: inline-block;
    font-weight: 400;
    margin-bottom: ${({ theme }) => theme.spacings.xs};
  }

  h4:first-of-type {
    text-align: left;
  }

  h4:first-of-type:first-letter {
    text-transform: capitalize;
  }

  h4:last-of-type {
    text-align: right;
  }

  div:last-of-type {
    width: 100%;
    height: 4px;
    position: relative;
    background: ${({ theme }) => theme.colors.silverBase};
    border-radius: ${({ theme }) => theme.utils.radius};
    overflow: hidden;
  }

  div:last-of-type::after {
    content: "";
    display: block;
    width: ${({ percent }) => percent}%;
    background: ${({ color }) => color};
    height: 100%;
    border-radius: inherit;
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    h4 {
      font-size: 0.875rem;
      margin-bottom: 0;
    }
  }
`;
//# sourceMappingURL=ProgressHorizontal.js.map